// Recent Activity feed data. Each source is a list the viewer may not be allowed to see (the
// server answers 403), so only the permitted lists are requested, and one failing list can't
// blank the others.
const SOURCES = [
  {
    permission: "contact-submissions",
    request: (api) => api.getContactSubmissions({ limit: 5 }),
    toActivity: (item) => ({
      ...item,
      type: "contact",
      color: "info",
      icon: "mail",
      title: `New contact from ${item.name}`,
      description: item.subject || "Contact form submission",
    }),
  },
  {
    permission: "bootcamp-applications",
    request: (api) => api.getBootcampApplications({ limit: 5 }),
    toActivity: (item) => ({
      ...item,
      type: "application",
      color: "success",
      icon: "assignment",
      title: `Bootcamp application from ${item.fullName || item.name}`,
      description: item.bootcamp?.title || "Bootcamp application",
    }),
  },
  {
    permission: "consultations",
    request: (api) => api.getConsultations({ limit: 5 }),
    toActivity: (item) => ({
      ...item,
      type: "consultation",
      color: "warning",
      icon: "event",
      title: `Consultation request from ${item.name}`,
      description: `${item.consultationType || "Consultation"} - ${
        item.preferredDate ? new Date(item.preferredDate).toLocaleDateString() : "Date pending"
      }`,
    }),
  },
];

// The 8 newest activities across the lists `hasPermission` allows.
export async function loadRecentActivities(api, hasPermission) {
  const allowed = SOURCES.filter((source) => hasPermission(source.permission));
  const settled = await Promise.allSettled(allowed.map((source) => source.request(api)));

  const activities = [];
  settled.forEach((result, index) => {
    if (result.status === "rejected") {
      console.error("Failed to fetch recent activity source:", result.reason);
      return;
    }
    (result.value?.items || []).forEach((item) => activities.push(allowed[index].toActivity(item)));
  });

  activities.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  return activities.slice(0, 8);
}

// Where "View All" goes: the first list the user may open (null when none).
const LIST_PATHS = ["contact-submissions", "bootcamp-applications", "consultations"];
export function viewAllPath(hasPermission) {
  const page = LIST_PATHS.find((p) => hasPermission(p));
  return page ? `/${page}` : null;
}
